module.exports = __webpack_public_path__ + "assets/ATrByCentroid.624a8f4eedcba64be8b7d652fe4e7b28.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ATrByCentroid.gmt
// module id = 888
// module chunks = 0